import AuthMiddleware from "@/middleware/auth"

const AllOrders = () =>
  import(/* webpackChunkName: "orders" */ "@/views/orders/AllOrders")
const ActiveOrders = () =>
  import(/* webpackChunkName: "orders" */ "@/views/orders/ActiveOrders")
const CompleteOrders = () =>
  import(/* webpackChunkName: "orders" */ "@/views/orders/CompleteOrders")
const ViewOrders = () =>
  import(/* webpackChunkName: "orders" */ "@/views/orders/ViewOrder")
const OrdersRouter = [
  {
    path: "/all-orders",
    name: "AllOrders",
    component: AllOrders,
    beforeEnter: AuthMiddleware.user,
    meta: {
      title: "LABSQUIRE ORDERS",
    },
  },
  {
    path: "/all-orders/active",
    name: "ActiveOrders",
    beforeEnter: AuthMiddleware.user,
    component: ActiveOrders,
    meta: {
      title: "LABSQUIRE ORDERS",
    },
  },
  {
    path: "/all-orders/finalized",
    name: "CompleteOrders",
    beforeEnter: AuthMiddleware.user,
    component: CompleteOrders,
    meta: {
      title: "LABSQUIRE ORDERS",
    },
  },
  {
    path: "/orders/:order_id",
    name: "Order-Information",
    component: ViewOrders,
    beforeEnter: AuthMiddleware.user,
  },
]

export { OrdersRouter }
